import client from './index'

export interface EvAreaPoint {
  lat: number
  lng: number
}

export interface EvArea {
  id: string
  name: string
  points: EvAreaPoint[]
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export interface CreateEvAreaDto {
  name: string
  points: EvAreaPoint[]
  is_active: boolean
}

export interface UpdateEvAreaDto {
  name?: string
  points?: EvAreaPoint[]
  is_active?: boolean
}

export const getEvAreas = () => {
  return client.get<EvArea[]>('/ev-areas')
}

export const createEvArea = (data: CreateEvAreaDto) => {
  return client.post<EvArea>('/ev-areas', data)
}

export const updateEvArea = (id: string, data: UpdateEvAreaDto) => {
  return client.put<EvArea>(`/ev-areas/${id}`, data)
}

export const deleteEvArea = (id: string) => {
  return client.delete(`/ev-areas/${id}`)
}

export const getEvAreaById = (id: string) => {
  return client.get<EvArea>(`/ev-areas/${id}`)
}

export const getEvAlertAreas = () => {
  return client.get<EvArea[]>('/ev-areas/alert')
}

export const createEvAlertArea = (data: CreateEvAreaDto) => {
  return client.post<EvArea>('/ev-areas/alert', data)
}

export const updateEvAlertArea = (id: string, data: UpdateEvAreaDto) => {
  return client.put<EvArea>(`/ev-areas/alert/${id}`, data)
}

export const deleteEvAlertArea = (id: string) => {
  return client.delete(`/ev-areas/alert/${id}`)
}
